var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_334_446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 19.5C18.42 19.5 18.795 19.35 19.11 19.035C19.425 18.72 19.575 18.36 19.575 17.925C19.575 17.49 19.425 17.13 19.11 16.815C18.795 16.5 18.435 16.35 18 16.35C17.565 16.35 17.205 16.5 16.89 16.815C16.575 17.13 16.425 17.49 16.425 17.925C16.425 18.36 16.575 18.72 16.89 19.035C17.205 19.35 17.565 19.5 18 19.5ZM16.875 14.7H19.125C19.125 13.98 19.2 13.44 19.35 13.11C19.5 12.78 19.845 12.33 20.4 11.775C21.15 11.025 21.645 10.425 21.9 9.96C22.155 9.495 22.275 8.955 22.275 8.325C22.275 7.2 21.885 6.285 21.09 5.565C20.295 4.845 19.275 4.5 18 4.5C16.98 4.5 16.08 4.785 15.315 5.37C14.55 5.955 14.025 6.705 13.725 7.665L15.75 8.49C15.975 7.86 16.275 7.395 16.665 7.08C17.055 6.765 17.49 6.615 18 6.615C18.6 6.615 19.095 6.78 19.47 7.125C19.845 7.47 20.04 7.92 20.04 8.49C20.04 8.835 19.935 9.165 19.74 9.48C19.545 9.795 19.185 10.185 18.69 10.665C17.865 11.385 17.355 11.955 17.175 12.375C16.995 12.795 16.89 13.575 16.89 14.715L16.875 14.7ZM9 24C8.175 24 7.47 23.7 6.885 23.115C6.3 22.53 6 21.825 6 21V3C6 2.175 6.3 1.47 6.885 0.885C7.47 0.3 8.175 0 9 0H27C27.825 0 28.53 0.3 29.115 0.885C29.7 1.47 30 2.175 30 3V21C30 21.825 29.7 22.53 29.115 23.115C28.53 23.7 27.825 24 27 24H9ZM9 21H27V3H9V21ZM3 30C2.175 30 1.47 29.7 0.885 29.115C0.3 28.53 0 27.825 0 27V6H3V27H24V30H3Z",
    fill: "#142862"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_334_446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faq_icon.64726081447780ce726afbee14724865.svg";
export { ForwardRef as ReactComponent };